import { combineReducers } from 'redux';
import blockAppMappingReducer from './blockAppMappingReducer';

export default combineReducers({
    blockAppMappingReducer
});
